import { defineMessages } from 'react-intl';

export const infoCallToActionMessages = defineMessages({
  Infotext: {
    id: 'ic-infoCallToAction-infotext',
    defaultMessage:
      'Die Ratenhöhe und die Laufzeit liegen in deinen Händen. Durch einfaches Anpassen der Laufzeit findest du deine persönliche Wunschrate.',
  },
});
